/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint @typescript-eslint/no-var-requires: "off" */
/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-loop-func */
import axios, { CancelTokenSource } from 'axios'
import moment from 'moment'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import ROUTES from 'utils/ROUTES'
import { formatToInputDateWDH } from 'utils/Common/date-utils'
import {
  AnnexContentForZip,
  ContentForZip,
} from 'utils/__interfaces/Billings/BillEntity'
import { BillsAndCreditsEntity } from 'utils/__interfaces/Billings/BillSynthesisEntity'
import {
  extractMaterialCleanDataFromRaw,
  extractMaterialTreatedCleanDataFromRaw,
  prepareTableBillsCredits,
  prepareTableSimpleData,
  prepareTableWithArray,
} from 'utils/Billings/Synthese-utils'
import { OrganizationType, InstitutionType } from 'store/state'
import OrganizationEntity from 'utils/__interfaces/Administrations/Organizations/OrganizationEntity'
import InstitutionEntity from 'utils/__interfaces/Perimeter/InstitutionEntity'
import DocumentTableEntity from 'utils/__interfaces/Documents/DocumentTableEntity'
import DocumentTableNormalizer from 'normalizer/DocumentTableNormalizer'
import {
  DocumentFamilyEntity,
  DocumentTypeEntity,
  FolderServiceEntity,
  ReportKpiEntry,
} from 'utils/__interfaces/Documents/DocumentEntity'
import flatFilter from 'utils/Filters/filter-utils'
import DocumentWDHTableNormalizer from 'normalizer/DocumentWDHTableNormalizer'
import { DocumentWDHTableEntity } from 'utils/__interfaces/Documents/DocumentTableAPI'
import {
  EnumTypeDocumentWdh,
  EnumDocTypeVisibility,
} from 'utils/__enums/MyDocuments/TypesDocument'
import BillingDownloadErrorNormalizer from 'normalizer/BillingDownloadErrorNormalizer'
import {
  getDocumentInfosById,
  kpiDownloadDocumentData,
} from 'utils/Documents/document-utils'
import {
  TABLE_DEFAULT_RESULT_PER_PAGE,
  TIME_OUT_TABLE,
} from 'utils/__consts/Common/Table'
import { getMemberData, hasNextPage } from './hydra-services'
import { incrementKpiDownloadDoc } from './kpi-service'
import { isCancel } from './billing-services'
import { extractLibelleFamillies } from './billing-synthesis-services'
import { getMyPerimeterOrganistaions } from './organization-services'
import { getListTransco } from './my-demands-services'

export interface ZipInfo {
  data: Blob
  docName: string
  dirName: string
  status: string
  message: string
}

export interface AnnexZipInfo extends ZipInfo {
  id: string
}

export interface DocumentUploadJson {
  docType?: string
  filename?: string
  companies?: any
  organisations?: any
  file?: any
  expireAt?: Date | null
}

let cancelTokenFolderServices: CancelTokenSource

const BRM_ENABLED = !!parseInt(process?.env?.REACT_APP_BRM_ENABLED || '1', 10)
const XlsxTemplate = require('xlsx-template')

const labelsToApiFieldsV2: { [key: string]: string } = {
  Nom: 'filename',
  Catégorie: 'docType.docFamily.label',
  Type: 'docType.label',
  'Ajouté le': 'createdAt',
  'Expire le': 'expireAt',
}

const labelsToApiFieldsWdh: { [key: string]: string } = {
  'Montant (HT)': 'montant',
  Numéro: 'numDocument',
  Date: 'anneeMois',
  'Numéro de dossier': 'codeDossier',
  'Ajouté le': 'dateDocument',
  'Émis le': 'dateDocument',
}

export async function downloadBlobFile(
  fileName: string,
  fileUrl: string,
  docType?: string
): Promise<number> {
  let reportData: Record<string, ReportKpiEntry> = {}
  let status = 400
  await axios
    .get(`${process.env.REACT_APP_BASE_API_WDH_URL}${fileUrl}`, {
      responseType: 'blob',
    })
    .then((response: any) => {
      if (response?.status === 200) {
        if (response?.data) {
          const urlBlob = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = urlBlob
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        }
      }
      status = response?.status
    })
    .catch((err: any) => {
      status = err.response ? err.response.status : 404
      console.log(`error doc`, err)
    })

  reportData = kpiDownloadDocumentData(
    reportData,
    docType ?? EnumTypeDocumentWdh.FACTURE,
    status
  )
  await incrementKpiDownloadDoc(reportData)
  return status
}

export async function downloadMultipleBlobFile(
  allFiles: Array<ContentForZip | AnnexContentForZip>,
  source = 'WDH'
): Promise<Array<ZipInfo | AnnexZipInfo>> {
  const zipInfos: Array<ZipInfo | AnnexZipInfo> = []
  let index = 0
  let status = 400
  let reportData: Record<string, ReportKpiEntry> = {}

  const baseUrl =
    source === 'WDH'
      ? process.env.REACT_APP_BASE_API_WDH_URL
      : process.env.REACT_APP_BASE_API_URL

  while (index < allFiles.length) {
    const tmpIndex = index
    const { docType } = allFiles[index]
    status = 400

    await axios
      .get(`${baseUrl}${allFiles[index].docUrl}`, {
        responseType: 'blob',
        validateStatus: (codeStatus: number) => {
          return codeStatus >= 200 && codeStatus < 500
        },
      })
      .then((response: any) => {
        if (response?.status === 200) {
          if (response?.data) {
            if ('id' in allFiles[index]) {
              const fileData = allFiles[index] as AnnexContentForZip
              zipInfos.push({
                id: fileData.id,
                data: response.data,
                docName: allFiles[tmpIndex].docName,
                dirName: allFiles[tmpIndex].dirName,
                status: response.status,
                message: '',
              })
            } else {
              zipInfos.push({
                data: response.data,
                docName: allFiles[tmpIndex].docName,
                dirName: allFiles[tmpIndex].dirName,
                status: response.status,
                message: '',
              })
            }
          }
        } else {
          let errorMessage = ''
          switch (response?.status) {
            case 404:
            case 204:
              errorMessage = "Le document n'est actuellement pas disponible."
              break
            default:
              errorMessage = 'Une erreur est survenue'
              break
          }
          if ('id' in allFiles[index]) {
            const fileData = allFiles[index] as AnnexContentForZip
            zipInfos.push({
              id: fileData.id,
              data: response.data,
              docName: allFiles[tmpIndex].docName,
              dirName: allFiles[tmpIndex].dirName,
              status: response.status,
              message: errorMessage,
            })
          } else {
            zipInfos.push({
              data: response.data,
              docName: allFiles[tmpIndex].docName,
              dirName: allFiles[tmpIndex].dirName,
              status: response.status,
              message: errorMessage,
            })
          }
        }
        status = response?.status
      })
      .catch((err: any) => {
        status = err.response ? err.response.status : 404
        let errorMessage = ''
        switch (err?.response?.status) {
          case 404:
          case 204:
            errorMessage = "Le document n'est actuellement pas disponible."
            break
          default:
            errorMessage = 'Une erreur est survenue'
            break
        }
        if ('id' in allFiles[index]) {
          const fileData = allFiles[index] as AnnexContentForZip
          zipInfos.push({
            id: fileData.id,
            data: err.response,
            docName: allFiles[tmpIndex].docName,
            dirName: allFiles[tmpIndex].dirName,
            status: err?.response?.status ?? err.message.slice(-3),
            message: errorMessage,
          })
        } else {
          zipInfos.push({
            data: err.response,
            docName: allFiles[tmpIndex].docName,
            dirName: allFiles[tmpIndex].dirName,
            status: err?.response?.status ?? err.message.slice(-3),
            message: errorMessage,
          })
        }
      })

    reportData = kpiDownloadDocumentData(reportData, docType, status)

    index += 1
  }
  await incrementKpiDownloadDoc(reportData)
  return zipInfos
}

async function prepareIntroductionPagedata(
  Organisation: OrganizationType,
  Etablissements: InstitutionType
): Promise<any[]> {
  // depends on the case
  // case all the perimetre
  if (Etablissements.items.length > 0) {
    return Etablissements.items.map((etab) => {
      return { name: `${etab.name}${etab.address}` }
    })
  }
  if (Organisation.items.length > 0) {
    return Organisation.items.map((orga) => {
      return { name: orga.name }
    })
  }
  const res = await getMyPerimeterOrganistaions()
  return res.entities.map((item) => {
    return { name: item.name }
  })
}

export async function GenerateExcelBillingSynthese(
  selectedYear: string,
  billsData: BillsAndCreditsEntity[],
  creditsdData: BillsAndCreditsEntity[],
  redeemedData: BillsAndCreditsEntity[],
  Organisation: OrganizationType,
  Etablissements: InstitutionType
) {
  // preparing data

  const Bills = extractMaterialCleanDataFromRaw(billsData)
  const credits = extractMaterialCleanDataFromRaw(creditsdData)
  const Redeemed = extractMaterialCleanDataFromRaw(redeemedData)
  const onlyCreditsFamilies = extractLibelleFamillies(creditsdData).filter(
    (item) => {
      return !extractLibelleFamillies(billsData).includes(item)
    }
  )
  const preparedBillsCredits = prepareTableBillsCredits(
    Bills,
    credits,
    onlyCreditsFamilies
  )
  const preparedReedemed = prepareTableSimpleData(Redeemed)
  const preparedIntroduction = await prepareIntroductionPagedata(
    Organisation,
    Etablissements
  )
  const response = await fetch(
    '/resources/SyntheseFacturationNoServiceRaw.xlsx'
  )
  response.arrayBuffer().then((buffer) => {
    const template = new XlsxTemplate(buffer)

    const values = {
      exportDate: moment(new Date()).format('DD/MM/YYYY'),
      year: selectedYear,
      data: preparedIntroduction,
    }
    template.substitute(1, values)

    // Bills & Credits by material
    const Materialvalues = {
      exportDate: moment(new Date()).format('DD/MM/YYYY'),
      year: selectedYear,
      data: preparedBillsCredits,
    }
    template.substitute(2, Materialvalues)
    // redeemed by material
    const RedeemedValues = {
      exportDate: moment(new Date()).format('DD/MM/YYYY'),
      year: selectedYear,
      data: preparedReedemed,
    }
    template.substitute(3, RedeemedValues)

    const result = template.generate({ type: 'arraybuffer' })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([result]))
    const day = moment(new Date()).format('YYYY_MM_DD')
    const filename = `Synthèse_Facturation_${day}.xlsx`
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
  })
}

export async function GenerateExcelBillingSyntheseNoBRM(
  selectedYear: string,
  billsData: BillsAndCreditsEntity[],
  creditsdData: BillsAndCreditsEntity[],
  Organisation: OrganizationType,
  Etablissements: InstitutionType
) {
  // preparing data

  const Bills = extractMaterialCleanDataFromRaw(billsData)
  const credits = extractMaterialCleanDataFromRaw(creditsdData)
  const onlyCreditsFamilies = extractLibelleFamillies(creditsdData).filter(
    (item) => {
      return !extractLibelleFamillies(billsData).includes(item)
    }
  )
  const preparedBillsCredits = prepareTableBillsCredits(
    Bills,
    credits,
    onlyCreditsFamilies
  )

  const preparedIntroduction = await prepareIntroductionPagedata(
    Organisation,
    Etablissements
  )

  fetch('/resources/SyntheseFacturationNoBRM.xlsx').then((response) => {
    response.arrayBuffer().then((buffer) => {
      const template = new XlsxTemplate(buffer)

      const introductionValues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        data: preparedIntroduction,
      }
      template.substitute(1, introductionValues)

      // Bills & Credits by material
      const Materialvalues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        year: selectedYear,
        data: preparedBillsCredits,
      }
      template.substitute(2, Materialvalues)

      const result = template.generate({ type: 'arraybuffer' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([result]))
      const day = moment(new Date()).format('YYYY_MM_DD')
      const filename = `Synthèse_Facturation_${day}.xlsx`
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
  })
}

export async function GenerateExcelActivitySynthese(
  selectedYear: string,
  operatedData: any[],
  treatedData: any[],
  SortRate: any[],
  passNumber: any[],
  Organisation: OrganizationType,
  Etablissements: InstitutionType
) {
  // preparing data
  const operated = extractMaterialCleanDataFromRaw(operatedData)
  const treated = extractMaterialTreatedCleanDataFromRaw(treatedData)
  const preparedOperated = prepareTableSimpleData(operated)
  const preparedTreated = prepareTableSimpleData(treated)
  const preparedSortRate = prepareTableWithArray(SortRate)
  const preparedPassNumber = prepareTableWithArray(passNumber)

  const preparedIntroduction = await prepareIntroductionPagedata(
    Organisation,
    Etablissements
  )

  fetch('/resources/SyntheseActivitesRaw.xlsx').then((response) => {
    response.arrayBuffer().then((buffer) => {
      const template = new XlsxTemplate(buffer)

      const introductionValues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        data: preparedIntroduction,
      }
      template.substitute(1, introductionValues)

      // Operated materials
      const Operatedvalues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        year: selectedYear,
        data: preparedOperated,
      }
      template.substitute(2, Operatedvalues)
      // treated materials
      const TreatedValues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        year: selectedYear,
        data: preparedTreated,
      }
      template.substitute(3, TreatedValues)

      // Bills & Credits by services
      const Sortvalues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        year: selectedYear,
        data: preparedSortRate,
      }

      template.substitute(4, Sortvalues)

      const Passvalues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        year: selectedYear,
        data: preparedPassNumber,
      }
      template.substitute(5, Passvalues)

      const result = template.generate({ type: 'arraybuffer' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([result]))
      const day = moment(new Date()).format('YYYY_MM_DD')
      const filename = `Synthèse_Activités_${day}.xlsx`
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
  })
}
export async function GenerateExcelEvolutionFactureTable(
  StartDate: Date,
  EndDate: Date,
  operatedData: any[]
) {
  const tmplt = BRM_ENABLED
    ? '/resources/detailFacturationRaw.xlsx'
    : '/resources/detailFacturationRawNoBRM.xlsx'
  fetch(tmplt).then((response) => {
    response.arrayBuffer().then((buffer) => {
      const template = new XlsxTemplate(buffer)
      //  facturation data
      const expotedValues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        StartDate: formatToInputDateWDH(StartDate, 'MM/YYYY', 'MM/YYYY'),
        EndDate: formatToInputDateWDH(EndDate, 'MM/YYYY', 'MM/YYYY'),
        evolutionFactures: operatedData,
      }
      template.substitute(1, expotedValues)

      const result = template.generate({ type: 'arraybuffer' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([result]))
      const day = moment(new Date()).format('YYYY_MM_DD')
      const filename = `Détail_Facturation_${day}.xlsx`
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
  })
}

export async function GenerateExcelEvolutionActivityTable(
  StartDate: Date,
  EndDate: Date,
  operatedData: any[]
) {
  fetch('/resources/detailActivitesRaw.xlsx').then((response) => {
    response.arrayBuffer().then((buffer) => {
      const template = new XlsxTemplate(buffer)
      //  facturation data
      const expotedValues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        StartDate: formatToInputDateWDH(StartDate, 'MM/YYYY', 'MM/YYYY'),
        EndDate: formatToInputDateWDH(EndDate, 'MM/YYYY', 'MM/YYYY'),
        evolutionActivites: operatedData,
      }
      template.substitute(1, expotedValues)

      const result = template.generate({ type: 'arraybuffer' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([result]))
      const day = moment(new Date()).format('YYYY_MM_DD')
      const filename = `Détail_Activités_${day}.xlsx`
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
  })
}
async function exportExcelFile(
  template: any,
  exportedValues: any,
  exportName: string
) {
  const day = moment(new Date()).format('YYYY_MM_DD')
  template.substitute(1, exportedValues)

  const result = template.generate({ type: 'arraybuffer' })
  const filename = `${exportName}_${day}.xlsx`
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(new Blob([result]))
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
}

export async function GenerateExcelEvolutionActivityMonthly(
  startDate: Date,
  endDate: Date,
  operatedData: any
) {
  fetch('/resources/DetailActivitesMensuelRaw.xlsx').then((response) => {
    response.arrayBuffer().then((buffer) => {
      const day = moment(new Date()).format('YYYY_MM_DD')
      const exportName = 'Détail_Activités'
      if (Object.entries(operatedData).length < 2) {
        const template = new XlsxTemplate(buffer)
        const exportedValues = {
          exportDate: moment(new Date()).format('DD/MM/YYYY'),
          startDate: moment(startDate).format('DD/MM/YYYY'),
          endDate: moment(endDate).format('DD/MM/YYYY'),
          year: Object.keys(operatedData)[0],
          detailsActivites: Object.values(operatedData)[0],
        }
        exportExcelFile(template, exportedValues, exportName)
      } else {
        const zip = new JSZip()
        Object.keys(operatedData).forEach((year) => {
          const template = new XlsxTemplate(buffer)
          const expotedValues = {
            exportDate: moment(new Date()).format('DD/MM/YYYY'),
            startDate: moment(startDate).format('DD/MM/YYYY'),
            endDate: moment(endDate).format('DD/MM/YYYY'),
            year,
            detailsActivites: operatedData[year],
          }
          template.substitute(1, expotedValues)
          const result = template.generate({ type: 'arraybuffer' })
          const filename = `${exportName}_${year}.xlsx`
          zip.file(filename, new Blob([result]))
        })
        const zipName = `${exportName}_${day}.zip`
        zip.generateAsync({ type: 'blob' }).then(function (content: any) {
          saveAs(content, zipName)
        })
      }
    })
  })
}

export async function GenerateExcelEvolutionBillingMonthly(
  startDate: Date,
  endDate: Date,
  operatedData: any
) {
  fetch('/resources/detailFacturationMensuelRaw.xlsx').then((response) => {
    response.arrayBuffer().then((buffer) => {
      const day = moment(new Date()).format('YYYY_MM_DD')
      const exportName = 'Détail_Facturation'
      if (Object.entries(operatedData).length < 2) {
        const template = new XlsxTemplate(buffer)

        const exportedValues = {
          exportDate: moment(new Date()).format('DD/MM/YYYY'),
          startDate: formatToInputDateWDH(startDate, 'MM/YYYY', 'MM/YYYY'),
          endDate: formatToInputDateWDH(endDate, 'MM/YYYY', 'MM/YYYY'),
          year: Object.keys(operatedData)[0],
          evolutionFactures: Object.values(operatedData)[0],
        }
        exportExcelFile(template, exportedValues, exportName)
      } else {
        const zip = new JSZip()
        Object.keys(operatedData).forEach((year) => {
          const template = new XlsxTemplate(buffer)
          const expotedValues = {
            exportDate: moment(new Date()).format('DD/MM/YYYY'),
            startDate: formatToInputDateWDH(startDate, 'MM/YYYY', 'MM/YYYY'),
            endDate: formatToInputDateWDH(endDate, 'MM/YYYY', 'MM/YYYY'),
            year,
            evolutionFactures: operatedData[year],
          }
          template.substitute(1, expotedValues)
          const result = template.generate({ type: 'arraybuffer' })
          const filename = `${exportName}_${year}.xlsx`
          zip.file(filename, new Blob([result]))
        })
        const zipName = `${exportName}_${day}.zip`
        zip.generateAsync({ type: 'blob' }).then(function (content: any) {
          saveAs(content, zipName)
        })
      }
    })
  })
}

export async function GenerateExcelDocumentsFacturationTable(
  exportedValues: any[]
) {
  const tmplt = '/resources/ExportDocumentsFacturation.xlsx'
  fetch(tmplt).then((response) => {
    response.arrayBuffer().then((buffer) => {
      const template = new XlsxTemplate(buffer)
      //  facturation data
      const expotedValues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        data: exportedValues,
      }
      template.substitute(1, expotedValues)

      const result = template.generate({ type: 'arraybuffer' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([result]))
      const day = moment(new Date()).format('YYYY_MM_DD')
      const filename = `Documents_de_facturation_${day}.xlsx`
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
  })
}

export const getDocumentTable = async (
  perPage: number,
  page: number,
  organisation: OrganizationEntity[] = [],
  institution: InstitutionEntity[] = [],
  sortTable: any,
  filters: { [key: string]: any | any[] },
  history: any,
  cancelToken: CancelTokenSource
): Promise<{
  results: DocumentTableEntity[]
  pageCount: number
  totalItems: number
  isTimeOut: boolean
}> => {
  const url = `${process.env.REACT_APP_BASE_API_URL}/documents`

  let listDocuments: DocumentTableEntity[] = []
  const params = new URLSearchParams()
  params.append(`page`, String(page))
  params.append(`perPage`, String(perPage))
  organisation.forEach((org) => {
    params.append(`idOrganisation[]`, org.id)
  })
  institution.forEach((insti) => {
    params.append(`companyId[]`, insti.id)
  })
  if (sortTable) {
    Object.keys(sortTable).forEach((key: string) => {
      params.append(`order[${labelsToApiFieldsV2[key]}]`, sortTable[key])
    })
  }

  flatFilter(params, filters)

  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
      cancelToken: cancelToken.token,
      timeout: TIME_OUT_TABLE,
    })

    if (resp?.data) {
      // Result Normalization
      listDocuments = DocumentTableNormalizer.normalize(
        getMemberData(resp.data)
      )
      const totalItems = parseInt(resp.data['hydra:totalItems'], 10)
      return {
        results: [...listDocuments],
        pageCount: Math.ceil(totalItems / perPage),
        totalItems,
        isTimeOut: false,
      }
    }
  } catch (err) {
    if (err?.code === 'ECONNABORTED') {
      return Promise.resolve({
        results: [],
        pageCount: 0,
        totalItems: 0,
        isTimeOut: true,
      })
    }
    if (isCancel(err)) {
      return Promise.resolve({
        pageCount: 0,
        results: err,
        totalItems: 0,
        isTimeOut: false,
      })
    }
    history.push(ROUTES.TechnicalError)
    throw new Error(`Erreur : ${err}`)
  }
  return Promise.resolve({
    pageCount: 0,
    results: [],
    totalItems: 0,
    isTimeOut: false,
  })
}

export async function downloadDocument(
  fileId: string,
  fileName: string
): Promise<number> {
  let reportData: Record<string, ReportKpiEntry> = {}
  let status = 400
  await axios
    .get(`${process.env.REACT_APP_BASE_API_URL}/documents/${fileId}/download`, {
      responseType: 'blob',
    })
    .then((response: any) => {
      if (response?.status === 200) {
        if (response?.data) {
          const urlBlob = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = urlBlob
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        }
      }
      status = response?.status
    })
    .catch((err: any) => {
      status = err.response ? err.response.status : 404
      console.log(`error doc`, err)
    })

  reportData = kpiDownloadDocumentData(
    reportData,
    EnumTypeDocumentWdh.AUTRES,
    status
  )
  await incrementKpiDownloadDoc(reportData)
  return status
}

// function to remove link between  document an d company
export async function removeDocument(
  documentId: string,
  history: any
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/documents/${documentId}`
  let status = 400
  try {
    const resp = await axios({
      method: 'DELETE',
      url,
    })

    status = resp?.status
  } catch (err) {
    history.push(ROUTES.TechnicalError)
    throw new Error(`Erreur : ${err}`)
  }
  return status
}

export async function getFamilies(): Promise<DocumentFamilyEntity[]> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/doc_families`

  try {
    const resp = await axios.get(url)
    const result = getMemberData(resp.data)

    if (result) {
      return Promise.all(result)
    }
  } catch (err) {
    throw new Error(
      `Erreur lors de l'appel de l'api getFamilies avec l'url: ${url}`
    )
  }
  return []
}

export async function getDocTypes(
  filter: EnumDocTypeVisibility[] = []
): Promise<DocumentTypeEntity[]> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/doc_types`
  const params = new URLSearchParams()

  filter.forEach((visibility) => {
    params.append(`visibleIn[]`, visibility)
  })

  try {
    const resp = await axios.get(url, { params })
    const result = getMemberData(resp.data)

    if (result) {
      return Promise.all(result)
    }
  } catch (err) {
    throw new Error(
      `Erreur lors de l'appel de l'api getDocTypes avec l'url: ${url}`
    )
  }
  return []
}

export async function getBase64File(
  file: File
): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve) => {
    let baseURL
    const reader = new FileReader()

    reader.readAsDataURL(file)
    reader.onload = () => {
      baseURL = reader.result
      resolve(baseURL)
    }
  })
}

export async function documentUploadJSON(
  file: string,
  fileName: string,
  companyIds: string[] = [],
  docType: string,
  expireAt: Date | null,
  organisationsIds: number[] = []
): Promise<any> {
  const companiesEntity = companyIds.map((company) => ({ companyId: company }))
  const organisationsEntity = organisationsIds.map((organisation) => ({
    organisationId: organisation.toString(),
  }))

  const doc: DocumentUploadJson = {
    docType,
    filename: fileName,
    file,
    expireAt,
  }

  if (companyIds.length) {
    doc.companies = companiesEntity
  }
  if (organisationsIds.length) {
    doc.organisations = organisationsEntity
  }

  const url = `${process.env.REACT_APP_BASE_API_URL}/documents`

  try {
    const resp = await axios({
      method: 'POST',
      url,
      data: doc,
    })

    return resp
  } catch (err) {
    throw new Error(
      `Erreur lors de l'appel de l'api DocumentUpload avec l'url: ${url}`
    )
  }
}

export async function getDocumentById(docId: string): Promise<any> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/documents/${docId}`

  try {
    const resp = await axios({
      method: 'GET',
      url,
      headers: {
        'content-type': 'application/json;',
      },
    })

    if (resp?.data) {
      return Promise.resolve(resp.data)
    }
  } catch (err) {
    throw new Error(
      `Erreur lors de l'appel de l'api DocumentUpload avec l'url: ${url}`
    )
  }

  return Promise.resolve([])
}

export async function patchDocument(
  doc: DocumentUploadJson,
  id: string
): Promise<any> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/documents/${id}`

  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data: doc,
    })

    return resp
  } catch (err) {
    throw new Error(
      `Erreur lors de l'appel de l'api DocumentUpload avec l'url: ${url}`
    )
  }
}

export async function getAttestationValorisation(
  numDebiteur = '',
  anneeReference = ''
): Promise<any> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/attestation_valorisation`
  const params = `?numDebiteur=${numDebiteur}&anneeRef=${anneeReference}`

  try {
    const resp = await axios({
      method: 'GET',
      url: url + params,
    })
    if (resp?.data) {
      return Promise.resolve(resp.data)
    }
  } catch (err) {
    throw new Error(
      `error when getting attestation valorisation with url: ${url}`
    )
  }

  return Promise.resolve([])
}

export async function downloadAttestationValorisation(
  idDoc = '',
  docName = ''
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/download_attestation_valorisation`
  const params = `?idDoc=${idDoc}`

  let reportData: Record<string, ReportKpiEntry> = {}
  let status = 400

  try {
    await axios({
      method: 'GET',
      url: url + params,
      responseType: 'blob',
    })
      .then((response: any) => {
        if (response?.status === 200) {
          if (response?.data) {
            const urlBlob = window.URL.createObjectURL(
              new Blob([response.data])
            )
            const link = document.createElement('a')
            link.href = urlBlob
            link.setAttribute('download', docName)
            document.body.appendChild(link)
            link.click()
          }
        }
        status = response?.status
      })
      .catch((err: any) => {
        console.log(`Upload`, err)
        status = err.response ? err.response.status : 404
      })

    reportData = kpiDownloadDocumentData(
      reportData,
      EnumTypeDocumentWdh.ATTESTATION_VALO,
      status
    )
    await incrementKpiDownloadDoc(reportData)
  } catch (err) {
    throw new Error(
      `error when downloading attestation valorisation with url: ${url}`
    )
  }

  return status
}

export async function getDocumentWdh(
  page: number,
  organisation: OrganizationEntity[] = [],
  institution: InstitutionEntity[] = [],
  sortTable: any,
  filters: { [key: string]: any | any[] },
  typesDocument: string[],
  history: any,
  cancelToken: CancelTokenSource
): Promise<{
  results: DocumentWDHTableEntity[]
  isTimeOut: boolean
  hasMorePage: boolean
}> {
  const url = `${process.env.REACT_APP_BASE_API_WDH_URL}/documents?page=${page}&perPage=${TABLE_DEFAULT_RESULT_PER_PAGE}`

  let listOfDocument: DocumentWDHTableEntity[] = []
  const params = new URLSearchParams()

  organisation.forEach((org) => {
    params.append(`idOrganisation[]`, org.id)
  })

  institution.forEach((insti) => {
    params.append(`fkEtablissementEntrepriseClient[]`, insti.id)
  })

  if (!('typeDocument' in filters) || filters.typeDocument?.length === 0) {
    typesDocument.forEach((type) => {
      params.append('typeDocument[]', type)
    })
  }

  if (sortTable) {
    Object.keys(sortTable).forEach((key: string) => {
      params.append(`order[${labelsToApiFieldsWdh[key]}]`, sortTable[key])
    })
  }

  flatFilter(params, filters)

  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
      cancelToken: cancelToken.token,
      timeout: TIME_OUT_TABLE,
    })

    if (resp?.data) {
      // Result Normalization
      listOfDocument = DocumentWDHTableNormalizer.normalize(
        getMemberData(resp.data)
      )
      const hasMorePage = hasNextPage(resp?.data)
      return {
        results: listOfDocument,
        hasMorePage,
        isTimeOut: false,
      }
    }
  } catch (err) {
    if (err?.code === 'ECONNABORTED') {
      return Promise.resolve({
        results: [],
        hasMorePage: false,
        isTimeOut: true,
      })
    }

    if (isCancel(err)) {
      return Promise.resolve({
        results: err,
        hasMorePage: false,
        isTimeOut: false,
      })
    }
    history.push(ROUTES.TechnicalError)
    throw new Error(`Erreur : ${err}`)
  }
  return Promise.resolve({
    results: [],
    hasMorePage: false,
    isTimeOut: false,
  })
}

export async function downloadZipDocsAsync(
  selectedDocs: string[]
): Promise<any> {
  let zipContainer: ContentForZip[] = []
  const zip = new JSZip()
  let errormessage = ''

  selectedDocs.forEach((id) => {
    const { idDocument, typeDocument, fileName } = getDocumentInfosById(id)
    zipContainer.push({
      docUrl: `/documents/${idDocument}/download`,
      docName: fileName,
      docType: typeDocument,
      dirName: '',
    })
  })

  // Warning message --> Only 40 for one zip
  if (zipContainer.length > 40) {
    zipContainer = zipContainer.slice(0, 40)
    errormessage = 'Seules vos 40 premières sélections ont été téléchargées.'
  }
  const finalZip = await downloadMultipleBlobFile(zipContainer)
  const totalFiles = finalZip.length
  const listFileWithError: any = []
  const listFileWithoutError: any = []
  finalZip?.forEach((item) => {
    const { message, docName } = item
    const idFacture = docName.split('.')[0]
    if (item.status.toString() !== '200') {
      listFileWithError.push({
        id: idFacture.replaceAll('_', ' '),
        fileName: idFacture.replaceAll('_', ' '),
        message,
        status: item.status,
      })
    } else {
      listFileWithoutError.push({
        data: item.data,
        docName: item.docName,
        dirName: item.dirName,
        status: item.status,
        message: '',
      })
    }
  })
  // Fill the zip
  if (listFileWithoutError.length > 0) {
    listFileWithoutError.map((zipinfo: ZipInfo) => {
      return zip.file(zipinfo.docName, zipinfo.data)
    })
    // Download Zip
    const zipName = `Documents_Suez.zip`

    zip.generateAsync({ type: 'blob' }).then(function (content: any) {
      saveAs(content, zipName)
    })
  }

  const categorizedErrors = BillingDownloadErrorNormalizer.normalize(
    listFileWithError
  )

  const listFileSuccess = listFileWithoutError.map((f: any) => {
    return {
      id: f.docName.slice(0, -4).replaceAll('_', ' ') as string,
      fileName: f.docName,
      message: 'download OK',
      status: 200,
    }
  })

  return {
    totalFiles,
    listFileWithError,
    categorizedErrors,
    listFileSuccess,
    errormessage,
  }
}
// Téléchargement multiple de documents ECE
export async function downloadManyDocuments(
  selectedDocs: string[]
): Promise<any> {
  let zipContainer: ContentForZip[] = []
  const zip = new JSZip()
  let errormessage = ''

  selectedDocs.forEach((doc) => {
    const [id, filename] = doc.split(';')

    zipContainer.push({
      docUrl: `/documents/${id}/download`,
      docName: `${filename}`,
      docType: EnumTypeDocumentWdh.AUTRES,
      dirName: '',
    })
  })

  // Warning message --> Only 40 for one zip
  if (zipContainer.length > 40) {
    zipContainer = zipContainer.slice(0, 40)
    errormessage = 'Seules vos 40 premières sélections ont été téléchargées.'
  }
  const finalZip = await downloadMultipleBlobFile(zipContainer, 'ECE')
  const totalFiles = finalZip.length
  const listFileWithError: any = []
  const listFileWithoutError: any = []
  finalZip?.forEach((item) => {
    const { message, docName } = item
    const idFacture = docName
    if (item.status.toString() !== '200') {
      listFileWithError.push({
        id: idFacture,
        fileName: idFacture,
        message,
        status: item.status,
      })
    } else {
      listFileWithoutError.push({
        data: item.data,
        docName: item.docName,
        dirName: item.dirName,
        status: item.status,
        message: '',
      })
    }
  })
  // Fill the zip
  if (listFileWithoutError.length > 0) {
    listFileWithoutError.map((zipinfo: ZipInfo) => {
      return zip.file(zipinfo.docName, zipinfo.data)
    })
    // Download Zip
    const zipName = `Autres_documents_Suez.zip`

    zip.generateAsync({ type: 'blob' }).then(function (content: any) {
      saveAs(content, zipName)
    })
  }

  const categorizedErrors = BillingDownloadErrorNormalizer.normalize(
    listFileWithError
  )

  const listFileSuccess = listFileWithoutError.map((f: any) => {
    return {
      id: f.docName,
      fileName: f.docName,
      message: 'download OK',
      status: 200,
    }
  })

  return {
    totalFiles,
    listFileWithError,
    categorizedErrors,
    listFileSuccess,
    errormessage,
  }
}

export const downloadBlobFileFromWDH = async (
  idDocument: string,
  filename: string,
  docType?: string
): Promise<number> => {
  let reportData: Record<string, ReportKpiEntry> = {}
  let status = 400
  await axios
    .get(
      `${process.env.REACT_APP_BASE_API_WDH_URL}/documents/${idDocument}/download`,
      {
        responseType: 'blob',
      }
    )
    .then((response: any) => {
      if (response?.status === 200) {
        if (response?.data) {
          const urlBlob = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = urlBlob
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        }
      }
      status = response?.status
    })
    .catch((err: any) => {
      status = err.response ? err.response.status : 404
      console.log(`error doc`, err)
    })

  reportData = kpiDownloadDocumentData(
    reportData,
    docType ?? EnumTypeDocumentWdh.FACTURE,
    status
  )
  await incrementKpiDownloadDoc(reportData)
  return status
}

export const loadListTranscoByCategory = async (
  category: string,
  ccapDetail: Partial<Record<EnumTypeDocumentWdh, string>>
) => {
  const transcoMap: Record<string, string> = {}
  try {
    await getListTransco(category).then((items) =>
      items
        .filter(
          (item) =>
            item.typeDemand === 'Demande' &&
            item.motifDemand === 'Documents' &&
            Object.values(ccapDetail).includes(item.detailDemand)
        )
        .forEach((item) => {
          transcoMap[item.detailDemand] = item.id
        })
    )
  } catch (err) {
    console.error(
      `Erreur lors de la récupération de la liste des transco : `,
      err
    )
  }
  return transcoMap
}

export const getFolderServices = async (
  codeFolder: string
): Promise<{
  results: FolderServiceEntity[]
}> => {
  const url = `${process.env.REACT_APP_BASE_API_WDH_URL}/dossier_services?codeDossierERP=${codeFolder}`

  let folderServices: FolderServiceEntity[] = []

  if (cancelTokenFolderServices !== undefined) {
    cancelTokenFolderServices.cancel('Operation canceled due to new request.')
  }

  cancelTokenFolderServices = axios.CancelToken.source()

  try {
    const resp = await axios({
      method: 'GET',
      url,
      cancelToken: cancelTokenFolderServices.token,
    })

    const memberData = getMemberData(resp?.data)
    folderServices = DocumentTableNormalizer.normalizeFolderServices(memberData)
  } catch (err) {
    if (isCancel(err)) {
      return Promise.resolve({
        results: err,
      })
    }
    throw new Error(`Erreur : ${err}`)
  }
  return Promise.resolve({
    results: folderServices,
  })
}
